<template>
  <div class="">
    <el-dialog :before-close="handleClose" :visible.sync="visible" :title="`设置微信分享库存信息`" :width="facility == 'pc' ? '500px' : '90%'" append-to-body :close-on-click-modal="false" center>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" status-icon>
        <el-form-item label="设置标题" prop="title">
          <el-input v-model="ruleForm.title" :maxlength="50" show-word-limit clearable placeholder="请填写标题"></el-input>
        </el-form-item>
        <el-form-item label="" prop=""></el-form-item>
        <el-form-item label="设置描述" prop="desc">
          <el-input v-model="ruleForm.desc" type="textarea" :maxlength="200" :rows="5" show-word-limit clearable placeholder="请填写描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small" round>取 消</el-button>
        <el-button @click="confirm" class="n-m-l-20" size="small" type="primary" round>确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "finalizeDialog",
  props: {
    // 显示
    visible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      ruleForm: {
        title: "",
        desc: "",
      },
      rules: {
        title: [
          { required: true, message: "请填写标题", trigger: "blur" },
        ],
        desc: [
          { required: true, message: "请填写描述", trigger: "blur" },
        ],
      },
      facility: sessionStorage.getItem('facility')
    };
  },
  computed: {

  },
  methods: {
    // 确认
    confirm () {
      this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          this.$emit("confirm", this.ruleForm);
        }
      });
    },
    // 关闭弹框
    cancel () {
      this.$emit("cancel", false);
    },
    // 右上角关闭按钮
    handleClose () {
      this.$emit("cancel", false);
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  color: #333 !important;
  font-weight: normal !important;
}

::v-deep .el-form-item.is-error .el-input__inner {
  border-color: #f56c6c !important;
}

::v-deep .el-input__inner {
  color: #606266 !important;
  border: 1px solid #dcdfe6 !important;

  &:focus {
    border-color: #409eff !important;
  }
}

::v-deep .el-form-item__content {
  padding-right: 0 !important
}

.dialog-footer {
  ::v-deep .el-button {
    width: 120px;
    font-size: 16px;

    &:nth-child(n+2) {
      margin-left: 20px !important;
    }

    &:hover {
      color: #2c9645;
      border-color: rgba($color: #2c9645, $alpha: .6);
      background-color: rgba($color: #2c9645, $alpha: .1);
    }

    &.el-button--primary {
      background-color: #2c9645;
      border-color: #2c9645;

      &:hover {
        color: #fff;
        background-color: rgba($color: #2c9645, $alpha: .8);
        border-color: rgba($color: #2c9645, $alpha: .8);
      }
    }
  }
}
</style>
